// This file is from santa-editor appMarketSDK
// I use it this way to avoid additional request to CDN.
// Use it as <script> tag if it gets updated often and you want to update it in an easy way.
// http://static.parastorage.com/services/santa-editor/1.1070.13/js/modules/appMarketSDK.js

// It have global _ dependency - fake it
const _ = {
    forEach: function(arr, fx) {
        return arr.forEach(fx);
    },
    isObject: function(obj) {
        return !!obj && typeof obj === 'object';
    }
};


/** API for App Market feature
 *
 * 1. Will run in a separate domain iframe
 * 2. Will pass A/B test apps in the url ==> param - test=testId*
 * 3. Communication with the editor will be done using post messages
 * 4. AppMarket API:
 *    init - initialize the AppMarket instance
 *    call - send command to the editor
 *
 * */
export default function AppMarket () {
    'use strict';

    var _w = {
      Commands: {
        ADD_APP_TO_SITE: 'ADD_APP_TO_SITE',
        ADD_COMPONENT_TO_SITE: 'ADD_COMPONENT_TO_SITE',
        OPEN_MARKET_POPUP: 'OPEN_MARKET_POPUP',
        OPEN_MODAL: 'OPEN_MODAL',
        CLOSE_MARKET_POPUP: 'CLOSE_MARKET_POPUP',
        CLOSE_MODAL: 'CLOSE_MODAL',
        GET_USER_DETAILS: 'GET_USER_DETAILS',
        GET_PENDING_APPS_LIST: 'GET_PENDING_APPS_LIST',
        REMOVE_PENDING_APP: 'REMOVE_PENDING_APP',
        ADD_PENDING_APP: 'ADD_PENDING_APP',
        APP_IS_INSTALLED: 'APP_IS_INSTALLED',
        OPEN_APP_MARKET_MODAL: 'OPEN_APP_MARKET_MODAL',
        CLOSE_APP_MARKET_MODAL: 'CLOSE_APP_MARKET_MODAL',
        CLOSE_APP_MARKET: 'CLOSE_APP_MARKET',
        OPEN_APP_MARKET_HELP: 'OPEN_APP_MARKET_HELP',
        SAVE: 'SAVE',
        OPEN_APP: 'OPEN_APP',
        SET_APP_MARKET_STATE: 'SET_APP_MARKET_STATE',
        IS_DEV_MODE: 'IS_DEV_MODE',
        OPEN_DELETE_POPUP_MESSAGE: 'OPEN_DELETE_POPUP_MESSAGE'
      },

      Events: {
        ON_MARKET_OPEN: 'ON_MARKET_OPEN',
        ON_COMMAND_RESPONSE: 'ON_COMMAND_RESPONSE'
      },

      callId: 1,

      callbacks: {},

      editorOrigin: '*',

      onOpenCallback: null,

      getQueryParameters: function (paramName) {
        var query = window.location.search.substring(1);

        var params = query.split('&').filter(function (item) {
          var i = item.split('=');
          return i[0] === paramName;
        });

        params.forEach(function (element, index, array) {
          array[index] = element.substring(paramName.length + 1);
        });

        return params;
      },

      receiver: function (event) {
        var data = null;
        if (event.origin === this.editorOrigin) {
          try {
            data = JSON.parse(event.data);
          } catch (e) {
            data = {};
          }
          switch (data.eventType) {
            case this.Events.ON_COMMAND_RESPONSE:
              if (data.callerId && this.callbacks[data.callerId]) {
                try {
                  this.callbacks[data.callerId](data.params);
                  delete this.callbacks[data.callerId];
                } catch (e) {
                  // Do nothing
                }
              }
              break;
          }
        }
      },

      getBlob: function (cmd, params, onResponseCallback) {
        var compId = _w.getQueryParameters('compId')[0] || 'MarketPanel';
        var blob = {intent: 'APP_MARKET', compId: compId, id: this.getCallId(), cmd: cmd, params: params};
        if (onResponseCallback) {
          this.callbacks[blob.id] = onResponseCallback;
        }

        return blob;
      },

      getCallId: function () {
        return _w.callId++;
      }
    };

    var init = function (onOpenCallback, callbackParams) {
      _w.onOpenCallback = {};
      _w.onOpenCallback.func = onOpenCallback;
      _w.onOpenCallback.params = callbackParams;

      // get the editor origin
      var originQueryParam = _w.getQueryParameters('eo')[0];
      var decodedQueryParam = decodeURIComponent(originQueryParam);
      _w.editorOrigin = (originQueryParam && window.atob(decodedQueryParam)) || _w.editorOrigin;

      window.addEventListener('message', _w.receiver.bind(_w), false);
    };

    init();

    return {
      /**
       * Initialize the message listener
       * and the market open callback
       * @param {Function} onOpenCallback - Function (will run in the iframe window context)
       * @param {Array} callbackParams - Array of params to pass the callback function
       */
      init: init,

      /** Function call
       * Pass a command to the editor
       *
       * @param cmd - from Commands
       * @param params - command specific
       * @param onResponseCallback - a callback function when the response is ready
       */
      call: function (cmd, params, onResponseCallback) {
        if (!cmd || !_w.Commands[cmd]) {
          return;
        }

        if (_w.editorOrigin) {
          var blob = _w.getBlob(cmd, params, onResponseCallback);
          var message = JSON.stringify(blob);

          window.parent.postMessage(message, _w.editorOrigin);
        }
      },

      /** Function addAppToSite
       * Add application to the editor stage
       *
       * @param appDefData
       * @param type
       * @param widgetId
       */
      addAppToSite: function (options) {
        this.call(_w.Commands.ADD_APP_TO_SITE, options);
      },


      save: function (onSuccess, onFailure) {
        var callback = function (result) {
          if (onSuccess && result && result.response === 'success') {
            onSuccess({
              metaSiteId: result.metaSiteId
            });
          } else if (onFailure) {
            onFailure(result.response);
          }
        };
        this.call(_w.Commands.SAVE, {}, callback);
      },

      /** Function addComponentToSite
       * Add application to the editor stage
       *
       * @param compType
       */
      addComponentToSite: function (compType, biData) {
        var compArgs;
        if (compType.indexOf('add') === 0) {//e.g. 'addFacebookLike'
          compArgs = {compType: compType, styleId: ''};
        } else {
          compArgs = JSON.parse(compType);
        }

        compArgs.biData = biData;
        this.call(_w.Commands.ADD_COMPONENT_TO_SITE, compArgs);
      },

      /**
       * Function openAppMarketModal
       * Open a modal in the editor
       *
       * @param url {String}
       * @param width {Number}
       * @param height {Number]
       * @param id {String}
       * @param [options] object containing optional settings:
       *  title
       *  shouldTranslateTitle - default is false
       *  closeModalBiEvent
       *  closeModalBiParams
       *
       * @example
       *
       * openAppMarketModal('http://my-site.com', 400, 500, 'uniqueId299',{title: 'My Modal'})
       */
      openAppMarketModal: function (url, width, height, id, options) {
        var mandatoryArguments = [url, width, height, id];
        _.forEach(mandatoryArguments, function(argument){
          if (argument === undefined){
            throw new Error('Missing mandatory arguments. [url, width, height, id] must be specified');
          }
        });

        var validateSizeParameter = function (key, value) {
          if (typeof value !== 'number' || value <= 0) {
            throw new Error('Invalid size argument. ' + key + ' should be a number greater than 0.');
          }
        };

        validateSizeParameter('width', width);
        validateSizeParameter('height', height);

        options = options || {};
        options.url = url;
        options.width = width;
        options.height = height;
        options.id = id;
        this.call(_w.Commands.OPEN_APP_MARKET_MODAL, options);
      },

      /**
       * Function closeAppMarketModal
       *
       * Close app market modal in editor by its id
       */
      closeAppMarketModal: function (id) {
        this.call(_w.Commands.CLOSE_APP_MARKET_MODAL, {id: id});
      },

      /**
        * Function closeAppMarket
        *
        * Close app market window
        */
      closeAppMarket: function () {
        this.call(_w.Commands.CLOSE_APP_MARKET);
      },

      /**
        * Function openAppMarketHelp
        *
        * Open editor's help for the app market
        */
        openAppMarketHelp: function () {
          this.call(_w.Commands.OPEN_APP_MARKET_HELP);
      },

      /**
       * Function openAppInfoModal
       * Open market info modal in editor (For Settings popup)
       *
       * @param url
       * @param width
       * @param height
       * @param closeCallback
       */
      openAppInfoModal: function (url, width, height, closeCallback) {
        this.call(_w.Commands.OPEN_MARKET_POPUP, {url: url, width: width, height: height}, closeCallback);
      },

      /**
       * Function openPermissionsModal
       * Open market permissions modal in editor
       *
       * @param url
       * @param width
       * @param height
       * @param appDefinitionId
       */
      openPermissionsModal: function (url, width, height, appDefinitionId) {
        this.call(_w.Commands.OPEN_MODAL, {
          url: url,
          width: width,
          height: height,
          appDefinitionId: appDefinitionId
        });
      },

      /**
       * Function closeAppPopup
       *
       * Close market popup in editor
       */
      closeAppPopup: function () {
        this.call(_w.Commands.CLOSE_MARKET_POPUP);
      },

      /**
       * Function closeModal
       *
       * Close market modal in editor.
       * @param action - could be add or cancel.
       */
      closeModal: function (action) {
        this.call(_w.Commands.CLOSE_MODAL, {action: action});
      },

      /**
       * Function getUserDetails
       *
       * @param callback
       */
      getUserDetails: function (callback) {
        this.call(_w.Commands.GET_USER_DETAILS, null, callback);
      },

      /**
       * Function getPendingAppsList
       *
       * @param callback function
       */
      getPendingAppsList: function (callback) {
        this.call(_w.Commands.GET_PENDING_APPS_LIST, null, callback);
      },

      /**
       * Function removePendingApp
       *
       * @param appId String
       */
      removePendingApp: function (appId) {
        this.call(_w.Commands.REMOVE_PENDING_APP, {id: appId});
      },

      /**
       * Function addPendingApp
       *
       * @param appId String
       */
      addPendingApp: function (appId) {
        this.call(_w.Commands.ADD_PENDING_APP, {id: appId});
      },

      /**
       * Function appIsInstalled - return if an app is installed
       *
       * @param options - an object containing appDefinitionId and includingDemoMode properties, or a string with appDefId (for backwards compatibility)
       * @param callback function
       */
      getIfAppIsInstalled: function (options, callback) {
        var args;
        if (_.isObject(options)) {
          if (!options.appDefinitionId){
            window.console.log('Invalid argument - options must contain appDefinitionId');
            return;
          }
          args = options;
        } else {
          args = {appDefinitionId: options};
        }
        this.call(_w.Commands.APP_IS_INSTALLED, args, callback);
      },

      /**
       * Function openApp - navigate to an installed app and open it settings panel
       *
       * @param appDefinitionId
       */
      openApp: function (appDefinitionId) {
        if (appDefinitionId) {
          this.call(_w.Commands.OPEN_APP, {
            appDefinitionId: appDefinitionId
          });
        } else {
          window.console.log('Mandatory arguments - appDefinitionId must be specified');
        }
      },


      /**
       * Function setAppMarketState - sets a state for the app market which will be concatenated to the app market url as a query param
       *
       * @param state
       */
      setAppMarketState: function (state) {
        if (typeof state === 'string') {
          this.call(_w.Commands.SET_APP_MARKET_STATE, {state: state});
        } else {
          window.console.log('Invalid argument - state must be a string');
        }
      },

      isDevMode: function (callback) {
        this.call(_w.Commands.IS_DEV_MODE, null, callback);
      },

      openDeletePopupMessage: function (options) {
        this.call(_w.Commands.OPEN_DELETE_POPUP_MESSAGE, options);
      }
    }
}



// WEBPACK FOOTER //
// ./services/app-market-sdk.js